import React from 'react';

const LoadingSmall = () => {
	return (
		<div className="loading-container-small">
			<div className="loadingSpinner"></div>
		</div>
	);
};

export default LoadingSmall;
